import type { FieldValues } from 'libs/form'

export const toAreaTypeFormData = (data: FieldValues, withImage: boolean) => {
	const formData = new FormData()

	formData.append('name', data.name)
	formData.append('description', data.description ?? '')
	formData.append('availability_algorithm', data.availability_algorithm)
	formData.append('primary_color', data.primary_color)
	formData.append('secondary_color', data.secondary_color)
	formData.append('dimensions.height', data.dimensions.height)
	formData.append('dimensions.width', data.dimensions.width)
	formData.append('dimensions.depth', data.dimensions.depth)

	if (withImage) {
		if (data.image) {
			formData.append('image', data.image, data.image.name)
		} else {
			formData.append('image', '')
		}
	}

	return formData
}
